<p-dropdown
  [options]="periods"
  [styleClass]="styleClass"
  [placeholder]="placeholder"
  [optionLabel]="optionLabel"
  [optionValue]="optionValue"
  [disabled]="disabled"
  [scrollHeight]="scrollHeight"
  [(ngModel)]="value"
  [showClear]="true"
  (onChange)="onChange($event)">
</p-dropdown> 